var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTruckActiveIcon = function SvgTruckActiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.605 1.25H8.728c.35 0 .656 0 .909.02.269.023.543.072.809.207.392.2.71.519.91.91.136.266.185.54.207.81.02.253.02.559.02.908V4.583H12.426c.125 0 .295 0 .462.04.145.034.283.091.41.17.146.089.266.21.354.298l.024.024 1.375 1.376.025.024c.088.088.209.208.299.354.077.127.134.265.17.41.04.167.039.337.038.462v1.882c0 .167 0 .334-.011.476-.013.158-.044.35-.143.544a1.417 1.417 0 0 1-.62.62c-.194.098-.386.13-.543.142a3.436 3.436 0 0 1-.197.01 2.417 2.417 0 1 1-4.473.002h-2.86a2.417 2.417 0 1 1-4.44-.08 1.781 1.781 0 0 1-.408-.147c-.392-.2-.711-.519-.91-.91a2.118 2.118 0 0 1-.207-.81C.75 9.217.75 8.91.75 8.562V4.105c0-.35 0-.655.02-.908.023-.27.072-.544.207-.81.2-.391.519-.71.91-.91.266-.135.54-.184.81-.206.253-.021.559-.021.908-.021ZM4.5 11.417a.917.917 0 1 0 0 1.833.917.917 0 0 0 0-1.833Zm7.333 0a.917.917 0 1 0 0 1.833.917.917 0 0 0 0-1.833Z",
    fill: "currentColor"
  })));
};

export default SvgTruckActiveIcon;